/* TwentySix cart drawer: add-on rail arrows, terms gate, header count, scroll reset.
   Quantity, remove and refresh stay with the theme's own cart-form; quick add is the site's cc-quick-add-sheet. */
(function () {
  if (window.__tsDrawer) return;
  window.__tsDrawer = true;

  /* ---------- add-on rail ---------- */
  function updateRail(wrap) {
    if (!wrap) return;
    var rail = wrap.querySelector('[data-ts-rail]');
    if (!rail) return;
    var max = rail.scrollWidth - rail.clientWidth;
    var pos = Math.abs(rail.scrollLeft);
    wrap.classList.toggle('no-scroll', max < 4);
    var prev = wrap.querySelector('[data-ts-rail-prev]');
    var next = wrap.querySelector('[data-ts-rail-next]');
    if (prev) prev.disabled = pos < 4;
    if (next) next.disabled = pos > max - 4;
  }

  function updateRails() {
    document.querySelectorAll('.ts-dr [data-ts-rail-wrap]').forEach(updateRail);
  }

  function moveRail(btn, dir) {
    var wrap = btn.closest('[data-ts-rail-wrap]');
    var rail = wrap && wrap.querySelector('[data-ts-rail]');
    if (!rail) return;
    var card = rail.firstElementChild;
    var step = card ? (card.getBoundingClientRect().width + 12) * 2 : 280;
    var rtl = getComputedStyle(rail).direction === 'rtl';
    rail.scrollBy({ left: (rtl ? -1 : 1) * dir * step, behavior: 'smooth' });
  }

  /* header bag count follows the drawer after quantity changes */
  function syncHeaderCount() {
    var state = document.querySelector('.ts-dr [data-ts-count]');
    if (!state) return;
    var count = parseInt(state.getAttribute('data-ts-count'), 10) || 0;
    document.querySelectorAll('.cart-link__count').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
    });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var scope = e.target.closest('.ts-dr');
    if (!scope) return;

    var prev = e.target.closest('[data-ts-rail-prev]');
    if (prev) { moveRail(prev, -1); return; }
    var next = e.target.closest('[data-ts-rail-next]');
    if (next) { moveRail(next, 1); return; }

    var checkout = e.target.closest('[data-ts-dr-checkout]');
    if (checkout) {
      var box = scope.querySelector('[data-ts-dr-terms-box]');
      if (box && !box.checked) {
        e.preventDefault();
        var terms = scope.querySelector('[data-ts-dr-terms]');
        if (terms) terms.classList.add('is-error');
        box.focus();
      }
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-ts-dr-terms-box]') && e.target.checked) {
      var terms = e.target.closest('[data-ts-dr-terms]');
      if (terms) terms.classList.remove('is-error');
    }
  });

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-ts-rail]')) updateRail(t.closest('[data-ts-rail-wrap]'));
  }, true);

  /* every opening starts at the top, where new items land; while open the cart sits above the accessibility button (see ts-drawer.css) */
  document.addEventListener('on:cart-drawer:before-open', function () {
    document.documentElement.classList.add('ts-cart-open');
    document.querySelectorAll('.ts-dr__body, .ts-dr__inner').forEach(function (el) { el.scrollTop = 0; });
  });
  document.addEventListener('on:cart-drawer:after-close', function () {
    document.documentElement.classList.remove('ts-cart-open');
  });
  document.addEventListener('on:cart-drawer:after-open', function () { setTimeout(updateRails, 30); });
  document.addEventListener('on:cart:after-merge', function () {
    syncHeaderCount();
    setTimeout(updateRails, 30);
  });
  window.addEventListener('resize', updateRails);

  /* the site's quick add (cc-quick-add-sheet) swaps the whole drawer content after adding; keep rails and count in step */
  var form = document.querySelector('cart-form.ts-dr');
  if (form && 'MutationObserver' in window) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].target === form) {
          syncHeaderCount();
          setTimeout(updateRails, 30);
          break;
        }
      }
    }).observe(form, { childList: true });
  }
})();
